import React from 'react';
import Footer from 'components/footer';

const FooterContainer = () => {
  return (
    <div>
      <Footer />
    </div>
  );
};

export default FooterContainer;
